import { ShieldCheck } from "lucide-react";

/**
 * Small pill shown on the university + degree detail pages when the
 * university has been claimed AND at least one owner has verified any
 * field. Consumed by `UniversityDetail.jsx` and `DegreeDetail.jsx`.
 */
export default function VerifiedByUniBadge({ lastUpdatedAt, updatedBy, compact = false }) {
  const dateStr = lastUpdatedAt
    ? new Date(lastUpdatedAt).toLocaleDateString(undefined, {
        month: "short",
        year: "numeric",
      })
    : null;
  if (compact) {
    return (
      <span
        data-testid="verified-by-uni-badge-compact"
        className="inline-flex items-center gap-1 text-[10px] font-underground-sc tracking-wider text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-full px-2 py-0.5"
      >
        <ShieldCheck className="h-3 w-3" />
        Verified by uni
      </span>
    );
  }
  return (
    <div
      data-testid="verified-by-uni-badge"
      className="inline-flex items-center gap-2 text-xs text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-md px-3 py-1.5"
    >
      <ShieldCheck className="h-3.5 w-3.5" />
      <span>
        Verified by the university
        {dateStr ? <span className="text-emerald-700"> · updated {dateStr}</span> : null}
        {updatedBy ? <span className="text-emerald-600"> · {updatedBy}</span> : null}
      </span>
    </div>
  );
}
